/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Service_ConsultingInputs */

const en_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulting`)
};

const es_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultoría`)
};

const fr_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulting`)
};

const de_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beratung`)
};

const ja_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンサルティング`)
};

const zh_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咨询服务`)
};

const ar_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استشارات`)
};

const id_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultasi`)
};

const it_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulenza`)
};

const ru_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Консалтинг`)
};

const pt_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultoria`)
};

const ko_listing_category_service_consulting = /** @type {(inputs: Listing_Category_Service_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컨설팅`)
};

/**
* | output |
* | --- |
* | "Consulting" |
*
* @param {Listing_Category_Service_ConsultingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_service_consulting = /** @type {((inputs?: Listing_Category_Service_ConsultingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Service_ConsultingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_service_consulting(inputs)
	if (locale === "es") return es_listing_category_service_consulting(inputs)
	if (locale === "fr") return fr_listing_category_service_consulting(inputs)
	if (locale === "de") return de_listing_category_service_consulting(inputs)
	if (locale === "ja") return ja_listing_category_service_consulting(inputs)
	if (locale === "zh") return zh_listing_category_service_consulting(inputs)
	if (locale === "ar") return ar_listing_category_service_consulting(inputs)
	if (locale === "id") return id_listing_category_service_consulting(inputs)
	if (locale === "it") return it_listing_category_service_consulting(inputs)
	if (locale === "ru") return ru_listing_category_service_consulting(inputs)
	if (locale === "pt") return pt_listing_category_service_consulting(inputs)
	return ko_listing_category_service_consulting(inputs)
});